module.exports = __webpack_public_path__ + "media/images/icons/location-5815a8547c935581b04e1b55598ec1b3.png";